import { render } from "./ActionsComponent.vue?vue&type=template&id=11e35708&scoped=true&ts=true&lang=pug"
import script from "./ActionsComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionsComponent.vue?vue&type=script&lang=ts&setup=true"

import "./ActionsComponent.vue?vue&type=style&index=0&id=11e35708&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e35708"]])

export default __exports__